import React, { Component } from 'react'
import './event-student-winners.scss'
import EventStudentWinnersList from './event-student-winners-list'

class EventStudentWinners extends Component {
  constructor (props) {
    super(props)
  }

  getEventWinnersList = (payload = {}) => {
    this.studentWinners.getEventWinnersList(payload);
  }

  render () {
    const {event} = this.props
    return (
      <>
        <div className='winners-list'>
          <div className='row'>
            <div className='col'>
              <div className='cw-plain-card cw-plain-card-wrapper-top mr-2 mb-3'>
                <div className='cw-plain-card-wrapper-winners'>
                  <EventStudentWinnersList
                    selectedClass={this.props.selectedClass}
                    ref={instance => {
                      this.studentWinners = instance
                    }}
                    event={event}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    )
  }
}

export default EventStudentWinners
